import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { Tags } from '../../models/tags/tags';

import { ApiResponse } from '@card-software/nexus-utilities';
@Injectable({
  providedIn: 'root',
})
export class TagsProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/tags';

  getTags(): Observable<ApiResponse<Tags[]>> {
    return this.httpClient.get<ApiResponse<Tags[]>>(`${this.baseUrl}/all`);
  }

  public createTags(tags: Tags): Observable<ApiResponse<Tags>> {
    return this.httpClient.post<ApiResponse<Tags>>(`${this.baseUrl}`, tags);
  }
}
